


















































import { Vue, Component } from 'vue-property-decorator';
import { getRankList } from '../api';

@Component
export default class WishRank extends Vue {
  rankList: any[] = [];
  async created() {
    const ret = await getRankList();
    this.rankList = ret.data;
  }
  onNavTo(rankItem: any) {
    this.$router.push({
      path: 'comments-with-tag',
      query: {
        tagId: rankItem.id,
        name: rankItem.name,
      },
    });
  }
}
